import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ProblemSection() {
  const revealRef = useScrollReveal();
  const problems = [{
    icon: '💬',
    title: 'Afirmaciones positivas',
    text: "Decías 'soy abundante' mientras tu inconsciente gritaba miedo. La frecuencia del miedo es 1,000 veces más potente que la palabra hablada. La contradicción interna bloqueaba todo cambio real.",
    borderColor: 'border-t-[#7B5CE8]'
  }, {
    icon: '🧠',
    title: 'Análisis intelectual',
    text: 'Entender POR QUÉ te hirieron no disuelve la carga atómica en tus células. La lógica es tridimensional; el trauma es no-local: está presente en todo tu campo energético simultáneamente.',
    borderColor: 'border-t-[#C9A96E]'
  }, {
    icon: '💪',
    title: 'Fuerza de voluntad',
    text: "Mientras 'intentas' cambiar, le envías al campo cuántico la señal de que algo está mal. El universo responde a tu estado de ser, no a tu esfuerzo.",
    borderColor: 'border-t-[rgba(250,247,242,0.3)]'
  }];
  return <section className="relative bg-brand-dark py-10 px-[5%] overflow-hidden" data-id="element-144">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,_rgba(123,92,232,0.15)_0%,_transparent_60%)] pointer-events-none" data-id="element-145" />

      <div ref={revealRef} className="max-w-7xl mx-auto relative z-10 reveal" data-id="element-146">
        <div className="text-center mb-[56px]" data-id="element-147">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-148">
            EL PROBLEMA
          </div>
          <h2 className="font-display italic text-[48px] text-brand-cream leading-tight mb-4" data-id="element-149">
            ¿Por qué lo que intentaste antes no funcionó?
          </h2>
          <p className="font-body text-[16px] text-brand-muted" data-id="element-150">
            No fue tu culpa. Fue el nivel desde el que operabas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-151">
          {problems.map((problem, i) => <div key={i} className={`bg-white/[0.03] border border-white/[0.07] border-t-[3px] ${problem.borderColor} rounded-[16px] p-[32px_28px] transition-all duration-300 hover:-translate-y-[4px] hover:border-brand-gold/30`} data-id="element-152">
              <div className="text-[32px] mb-4" data-id="element-153">{problem.icon}</div>
              <h3 className="font-body text-[16px] font-medium text-brand-cream mb-3" data-id="element-154">
                {problem.title}
              </h3>
              <p className="font-body text-[14px] text-brand-muted leading-[1.7]" data-id="element-155">
                {problem.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}